import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

interface BellProps extends SVGProps {
  filled?: boolean;
}

export const Bell: FC<BellProps> = ({ onClick, divClassName, filled }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      {filled
      ?
        <path 
          d="M12 29.625C13.65 29.625 15 28.275 15 26.625H9C9 28.275 10.335 29.625 12 29.625ZM21 20.625V13.125C21 8.52 18.54 4.665 14.25 3.645V2.625C14.25 1.38 13.245 0.375 12 0.375C10.755 0.375 9.75 1.38 9.75 2.625V3.645C5.445 4.665 3 8.505 3 13.125V20.625L0 23.625V25.125H24V23.625L21 20.625Z" 
          fill="#0D66DC"
        />
      :
        <path 
          d="M12 30C13.65 30 15 28.65 15 27H9C9 28.65 10.35 30 12 30ZM21 21V13.5C21 8.895 18.555 5.04 14.25 4.02V3C14.25 1.755 13.245 0.75 12 0.75C10.755 0.75 9.75 1.755 9.75 3V4.02C5.46 5.04 3 8.88 3 13.5V21L0 24V25.5H24V24L21 21ZM18 22.5H6V13.5C6 9.78 8.265 6.75 12 6.75C15.735 6.75 18 9.78 18 13.5V22.5Z" 
          fill="#3273E1"
        />
      }
    </svg>
  </SvgWrapper>
)
